/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import cx from 'classnames';
import {Typography} from '~library/atoms/Typography';
import {eviteVendors} from './vendors';

import './VendorLogos.sass';

const findIcon = (vendorName) =>
  eviteVendors.find((vendor) => vendor.name.toLowerCase() === vendorName.toLowerCase());

const amazonIcon = findIcon('amazon');
const targetIcon = findIcon('target');
const walmartIcon = findIcon('walmart');

export const VendorLogos = ({noGap = false}) => (
  <div
    className={cx({
      vendors__logos: true,
      'vendors__logos--no-gap': noGap,
    })}
  >
    {amazonIcon && (
      <img src={amazonIcon.icon_url} alt={amazonIcon.name} className="vendors__logos__amazon" />
    )}
    {targetIcon && (
      <img src={targetIcon.icon_url} alt={targetIcon.name} className="vendors__logos__target" />
    )}
    {walmartIcon && (
      <img src={walmartIcon.icon_url} alt={walmartIcon.name} className="vendors__logos__walmart" />
    )}
    <Typography variant="list2" color="coin">
      + more
    </Typography>
  </div>
);
